import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { copyToClipboard } from '../../utils/clipboard.util';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
})
export class InputTextComponent implements OnChanges, OnDestroy {
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() type: string = 'text';
  @Input() isDisabled: boolean = false;
  @Input() control: FormControl = new FormControl();
  @Input() size: 'small' | 'default' | 'large' = 'small';
  @Input() showClear: boolean = false;
  @Input() nzHasFeedback: boolean = true;
  /** Shows a copy addon at the end of the input. */
  @Input() showCopy: boolean = false;

  public copied: boolean = false;
  private copiedTimer: any = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isDisabled']) {
      if (this.isDisabled) {
        this.control.disable();
      } else {
        this.control.enable();
      }
    }
  }

  ngOnDestroy() {
    clearTimeout(this.copiedTimer);
  }

  clearInput() {
    this.control.setValue('');
  }

  copyText(): string {
    const value = this.control?.value;
    return value === null || value === undefined ? '' : String(value);
  }

  copyValue(): void {
    const text = this.copyText();
    if (!text.trim()) {
      return;
    }

    copyToClipboard(text).then(() => {
      clearTimeout(this.copiedTimer);
      this.copied = true;
      this.copiedTimer = setTimeout(() => (this.copied = false), 1500);
    });
  }

  isRequired(control: AbstractControl | null): boolean {
    if (!control || !control.validator) {
      return false;
    }
    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'] ? true : false;
  }
}
